module.exports = __webpack_public_path__ + "img/doctor.9ef076e7.png";